import type { TemplateSlot } from "../utils/derive-template";
import { CATEGORY_DOT_COLORS } from "../../../shared/types";

interface ScheduleSlotCardProps {
  readonly slot: TemplateSlot;
  readonly onEdit: (slot: TemplateSlot) => void;
  readonly onContextMenu?: (slot: TemplateSlot, anchorRect: DOMRect) => void;
}

export function ScheduleSlotCard({ slot, onEdit, onContextMenu }: ScheduleSlotCardProps) {
  const handleContextMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (onContextMenu) {
      onContextMenu(slot, e.currentTarget.getBoundingClientRect());
    }
  };

  return (
    <button
      type="button"
      onClick={() => onEdit(slot)}
      onContextMenu={handleContextMenu}
      className="w-full text-left p-2.5 rounded-lg border border-border bg-surface hover:bg-surface-alt transition-colors group"
    >
      <div className="flex items-center gap-2 min-w-0">
        <div
          className={`w-2 h-2 rounded-full shrink-0 ${CATEGORY_DOT_COLORS[slot.category]}`}
        />
        <span className="text-sm font-medium text-ink truncate">
          {slot.title}
        </span>
      </div>
      <div className="text-xs text-ink-muted mt-0.5 pl-4">
        {slot.startTime} – {slot.endTime}
      </div>
      {slot.tags.length > 0 && (
        <div className="flex gap-1 mt-1 pl-4 flex-wrap">
          {slot.tags.map((tag) => (
            <span
              key={tag}
              className="text-[10px] px-1.5 py-0.5 bg-surface-alt rounded text-ink-muted"
            >
              {tag}
            </span>
          ))}
        </div>
      )}
    </button>
  );
}
